import CreatorAccountsTable from '../../../CreatorAccountsTable/CreatorAccountsTable';
import { BulkUploadItemRow, toCreatorAccountRow } from '../../helpers';
import AddUploadToPool from './components/AddUploadToPool/AddUploadToPool';
import styles from './CreatedItems.module.css';

type Props = {
    rows: BulkUploadItemRow[];
    isExploreLoading: boolean;
    isImagesLoading: boolean;
    isProcessing: boolean;
};

/** The creators the upload created, with the way to add them all to a pool above them. */
const CreatedItems = ({ rows, isExploreLoading, isImagesLoading, isProcessing }: Props) => (
    <div className={styles.createdItems}>
        <AddUploadToPool rows={rows} isProcessing={isProcessing} />
        <CreatorAccountsTable
            rows={rows.map(toCreatorAccountRow)}
            isExploreLoading={isExploreLoading}
            isImagesLoading={isImagesLoading}
        />
    </div>
);

export default CreatedItems;
